import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    serviceType: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real implementation, this would send the form data to a server
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      serviceType: '',
      message: ''
    });
    // Reset submission state after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };
  return <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-106">
      <div className="text-center mb-16" data-id="element-107">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-108">お問い合わせ</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-109">
          サービスに関するご質問、お見積りのご依頼など、お気軽にお問い合わせください。
        </p>
      </div>
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-111">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-112">
            <div data-id="element-113">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-114">
                お名前
              </label>
              <input type="text" name="name" id="name" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" placeholder="山田 太郎" data-id="element-115" />
            </div>
            <div data-id="element-116">
              <label htmlFor="company" className="block text-sm font-medium text-gray-700" data-id="element-117">
                会社名
              </label>
              <input type="text" name="company" id="company" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" placeholder="株式会社〇〇" data-id="element-118" />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-119">
            <div data-id="element-120">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-121">
                メールアドレス
              </label>
              <input type="email" name="email" id="email" required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" placeholder="your@email.com" data-id="element-122" />
            </div>
            <div data-id="element-123">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-124">
                電話番号
              </label>
              <input type="tel" name="phone" id="phone" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" placeholder="03-1234-5678" data-id="element-125" />
            </div>
          </div>
          <div data-id="element-126">
            <label htmlFor="service" className="block text-sm font-medium text-gray-700" data-id="element-127">
              ご希望のサービス
            </label>
            <select id="service" name="service" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" data-id="element-128">
              <option value="" data-id="element-129">選択してください</option>
              <option value="hotel" data-id="element-130">ホテル清掃</option>
              <option value="airbnb" data-id="element-131">民泊施設清掃</option>
              <option value="office" data-id="element-132">オフィス清掃</option>
              <option value="other" data-id="element-133">その他</option>
            </select>
          </div>
          <div data-id="element-134">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-135">
              お問い合わせ内容
            </label>
            <textarea id="message" name="message" rows={4} required className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" placeholder="ご要望やご質問をご記入ください" data-id="element-136"></textarea>
          </div>
          <div className="flex items-start" data-id="element-137">
            <input id="privacy" name="privacy" type="checkbox" required className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1" data-id="element-138" />
            <label htmlFor="privacy" className="ml-2 block text-sm text-gray-700" data-id="element-139">
              プライバシーポリシーに同意します
            </label>
          </div>
          <div className="text-center" data-id="element-140">
            <button type="submit" className="inline-flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-141">
              送信する
              <ArrowRightIcon className="ml-2 -mr-1 h-5 w-5" data-id="element-142" />
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default ContactForm;